<!--
  <MultiChart
    title="My title"
    :chardata="chardata"
  >

    chardata = {
      name: 'Pi',
      entries: {
        "Serie name": {
          "data": [
            {name: 'Bar1', y:   3},
            {name: 'Bar2', y:  14},
            {name: 'Bar3', y:  15},
            {name: 'Bar4', y:  93},
          ],
          "type": 'column' 
            //Chart type, aviable: 'column' & 'spline'
            // DO NOT USE: 'bar' chart type

          "color": '#ffffff',
          "suffix": '°C'
        },
        "Serie Name 2": {
          ...
        },
      },
    }
-->

<template>
  <highcharts
    :options="chart_options"
    ref="chart"
    style="width: 100%; height: 100%;"
  />
</template>
  
  
<style lang="scss">
</style>
  
  
<script>
  
  export default {
    name: "MultiChart",
  
    props: {
      title: {required: true},
      subtitle: {required: false},
      chardata: {required: true},
    },
  
    computed: {
      chart_options() {
        return {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: '',
          },
          subtitle: {
            text: this.subtitle,
          },

          xAxis: {
            type: 'category',
            title: {
              text: null
            },
            accessibility: {
              description: this.subtitle,
            }
          },
          yAxis: {
            title: {
              text: null,
            },
            labels: {
              overflow: 'justify',
              format: '{value}'
            }
          },
  
          series: Object.entries(this.chardata.entries).map(([key, values]) => (
                    {
                      ...values,
                      name: key,
                      tooltip: {...(values.tooltip||{}), valueSuffix: values.suffix}
                    }
                  )),
  
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                format: '{y}'
              }
            }
          },
          tooltip: {
            valueSuffix: '',
            stickOnContact: true,
            backgroundColor: 'rgba(255, 255, 255, 0.93)'
          },
          legend: {
            enabled: false
          },
        };
      },
    },
  };   
</script>
  